import { DealerMinimal } from './dealer-minimal';

export class RemittanceDealerBankAccountsRequest {
  //#region : Constructor :
  constructor() {
    this.dealer = null;
  }
  //#endregion

  //#region : Properties :
  public userName: string;
  public dealerCode: string;
  public programCode: string;
  public dealer: DealerMinimal;
  public useSefi: boolean;
  //#endregion
}
